import(/* webpackMode: "eager" */ "/home/runner/workspace/artifacts/legible-web/src/app/login/page.tsx");
